﻿/* exported EventsManager */
var EventsManager = (function ()
{
    var __globalListeners = {};

    function EventsManager()
    {
        this._listeners = {};
    }

    EventsManager.prototype.addEventListener = function (type, context, callback, global)
    {
        var listeners = global ? __globalListeners : this._listeners;
        if (!listeners[type])
        {
            listeners[type] = [];
        }

        if (listeners[type].map(function(listener){return listener.callback;}).indexOf(callback) === -1) {
            listeners[type].push({
                callback: callback, context: context
            });
        }
    };

    EventsManager.prototype.removeEventListener = function (type, context, global)
    {
        var listeners = global ? __globalListeners : this._listeners;
        var listenersByType = listeners[type];
        if (!listenersByType)
        {
            return;
        }
        var index = -1;
        for (var i = 0; i < listenersByType.length; i += 1)
        {
            var eventListener = listenersByType[i];
            if (eventListener.context === context)
            {
                index = i;
                break;
            }
        }
        if (index != -1)
        {
            listenersByType.splice(index, 1);
        }
    };

    EventsManager.prototype.dispatchEvent = function (type, data, global)
    {
        var listeners = global ? __globalListeners : this._listeners;
        var listenersByType = listeners[type];
        if (!listenersByType)
        {
            return;
        }
        for (var i = 0; i < listenersByType.length; i += 1)
        {
            var listener = listenersByType[i];
            listener.callback.call(listener.context, data);
        }
    };

    return EventsManager;
}());

window.EventsManager = EventsManager;
